import * as transformers from '@attain-apps/transformers'

// TODO: Add jsDoc
export const UI = new transformers.Factory('ui')
